// extracted by mini-css-extract-plugin
module.exports = {"override":"override___p4k3H"};